import {buildUrl, snakeToCamel, toSnakeCase, camelToSnake, excludeObjNullValue} from 'utils/common';


export const config = {
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    mode: 'cors',
};

export const setAuthHeader = (token) => {
    if (token) {
        config.headers['Auth-Token'] = token;
    } else {
        delete config.headers['Auth-Token'];
    }
};

const preprocess = response => {
    if (response.status === 204) {
        return Promise.resolve({
            status: response.status,
        });
    } else if (response.status >= 100 && response.status <= 399) {
        return response.json().then(data => snakeToCamel(data));
    } else {
        return response.json().then(data => Promise.reject(snakeToCamel({
            ...data,
            status: response.status,
        })));
    }
};

const getJSON = (url, query = {}) => (
    fetch(
        buildUrl(url, query),
        config,
    )
        .then(preprocess)
);

const postJSON = (url, payload, query = {}) => (
    fetch(
        buildUrl(url, query),
        {
            ...config,
            method: 'POST',
            body: JSON.stringify(payload),
        },
    )
        .then(preprocess)
);

const putJSON = (url, payload, query = {}) => (
    fetch(
        buildUrl(url, query),
        {
            ...config,
            method: 'PUT',
            body: JSON.stringify(payload),
        },
    )
        .then(preprocess)
);

const patchJSON = (url, payload, query = {}) => (
    fetch(
        buildUrl(url, query),
        {
            ...config,
            method: 'PATCH',
            body: JSON.stringify(payload),
        },
    )
        .then(preprocess)
);

const postForm = (url, formData, query = {}) => (
    fetch(
        buildUrl(url, query),
        {
            ...config,
            headers: {
                'Accept': config.headers['Accept'],
                'Auth-Token': config.headers['Auth-Token'],
            },
            method: 'POST',
            body: formData,
        },
    )
        .then(preprocess)
);

const putForm = (url, formData, query = {}) => (
    fetch(
        buildUrl(url, query),
        {
            ...config,
            headers: {
                'Accept': config.headers['Accept'],
                'Auth-Token ': config.headers['Auth-Token'],
            },
            method: 'PUT',
            body: formData,
        },
    )
        .then(preprocess)
);

const deleteReq = (url, query = {}) => (
    fetch(
        buildUrl(url, query),
        {
            ...config,
            method: 'DELETE',
        },
    )
        .then(preprocess)
);

const fetchList = ({url, q, page = 1, perPage = 10, sortOpts = {}, extraParams = {}}) => getJSON(
    url,
    excludeObjNullValue({
        q,
        page,
        per_page: perPage,
        sort_field: typeof sortOpts.sortField === 'string' ? toSnakeCase(sortOpts.sortField) : undefined,
        sort_dir: sortOpts.sortDir,
        ...camelToSnake(extraParams),
    })
);

const fetchDetail = (url) => getJSON(url, {detailed: true});

const postFile = (url, payload, query = {}) => (
    fetch(
        buildUrl(url, query),
        {
            headers: {
                'Accept': config.headers['Accept'],
                'Auth-Token': config.headers['Auth-Token'],
            },
            method: 'POST',
            body: payload,
        },
    )
        .then(preprocess)
);

export default {
    getJSON,
    postJSON,
    putJSON,
    patchJSON,
    postForm,
    putForm,
    deleteReq,
    fetchList,
    fetchDetail,
    postFile,
};
